import InnerComponent from '@Components/Purchase/PurchaseRequests/UpdatePurchaseRequest';
import orgContainer from '@Components/AppContainer';

const UpdatePurchaseRequest = () => ((orgContainer(InnerComponent)));
export default UpdatePurchaseRequest;
